interface IMetaDescription {
  title: string
}

const CPGJOBS_SITE_NAME = 'CPGJobs.com by BevNET CPG Media';
const CPGJOBS_DESCRIPTION = "The CPG industry's job board. Find and post beverage, food, and consumer-packaged-goods jobs. Brought to you by BevNET CPG Media.";

// Pure <title>/meta component. The per-site gtag (G-L0JJ20QS9D / G-LV4GXHHTGK /
// G-98C547X4YE) and per-site GTM containers (GTM-PQ9VGWC7 / GTM-M4MRHMPX /
// GTM-WB8DHGMN) this used to inject on variant pages were removed (D-24588):
// all jobs-app tracking is consolidated in GTM-K4WKF75L (public/index.html),
// which carries GA4 G-HBR82YG9EZ, HubSpot and Google Ads.
export const MetaDescription = ({ title }:IMetaDescription) => {
  return (
    <>
      <title>{title}</title>
      <link
        rel="icon"
        type="image/svg+xml"
        href="/icon.svg"
      />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:site_name"
        content={CPGJOBS_SITE_NAME}
      />
      <meta
        property="og:description"
        content={CPGJOBS_DESCRIPTION}
      />
      <meta
        name="twitter:card"
        content="summary"
      />
      <meta
        name="twitter:title"
        content={title}
      />
      <meta
        name="twitter:description"
        content={CPGJOBS_DESCRIPTION}
      />
    </>
  );
};
